<template>
  <NuxtLink to="/hitungProduct" class="ticker-wrapper">
    <div class="ticker-label">🔔 UPDATE TERBARU</div>
    <div class="ticker-scroll-area">
      <div class="ticker-content">
        {{ fullText }}
      </div>
    </div>
  </NuxtLink>
</template>

<script setup>
const messages = [
  '✅ UPDATE: Kalkulasi Tokopedia/TikTok Shop sudah diperbarui sesuai kebijakan baru per 18 Mei 2026 — termasuk komisi dinamis baru & biaya layanan logistik',
  '✅ UPDATE: Kalkulasi Shopee sudah diperbarui sesuai tarif Biaya Administrasi terbaru per Januari 2026',
  '🔥 Biaya komisi Tokopedia naik mulai 18 Mei 2026 — Hitung ulang harga jualmu sekarang!'
]

const divider = '\u00A0\u00A0\u00A0⭐\u00A0\u00A0\u00A0'
const joined = messages.join(divider)
const fullText = joined + divider + joined + divider
</script>

<style scoped>
.ticker-wrapper {
  display: flex;
  width: 100%;
  background: #16a34a;
  overflow: hidden;
  align-items: center;
  text-decoration: none;
  cursor: pointer;
}

.ticker-label {
  background: #15803d;
  color: white;
  font-size: 12px;
  font-weight: 700;
  padding: 10px 16px;
  white-space: nowrap;
  flex-shrink: 0;
  z-index: 1;
}

.ticker-scroll-area {
  flex: 1;
  overflow: hidden;
  padding: 10px 0;
}

.ticker-content {
  display: inline-block;
  white-space: nowrap;
  color: white;
  font-size: 13px;
  font-weight: 500;
  animation: ticker-scroll 60s linear infinite;
}

@keyframes ticker-scroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}
</style>
